"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function SponsorGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const sponsors = [{
    id: 1,
    name: "TechVision Inc",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1529558/img/sponsor_techvision_logo.png",
    url: "https://www.techvision.com"
  }, {
    id: 2,
    name: "DataCore Systems",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1529558/img/sponsor_datacore_logo.png",
    url: "https://www.datacore.com"
  }, {
    id: 3,
    name: "CloudNet Solutions",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1529558/img/sponsor_cloudnet_logo.png",
    url: "https://www.cloudnet.com"
  }, {
    id: 4,
    name: "InnovateLab",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1529558/img/sponsor_innovatelab_logo.png",
    url: "https://www.innovatelab.com"
  }, {
    id: 5,
    name: "NextGen Analytics",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1529558/img/sponsor_nextgen_logo.png",
    url: "https://www.nextgen.com"
  }, {
    id: 6,
    name: "Quantum Dynamics",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1529558/img/sponsor_quantum_logo.png",
    url: "https://www.quantum.com"
  }, {
    id: 7,
    name: "FutureTech Corp",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1529558/img/sponsor_futuretech_logo.png",
    url: "https://www.futuretech.com"
  }, {
    id: 8,
    name: "AlphaCode Industries",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1529558/img/sponsor_alphacode_logo.png",
    url: "https://www.alphacode.com"
  }];
  return;
}